export { onlineAddToCart } from './base-atc.trigger';
